import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    this.showTab(0)
  }

  switch(event) {
    const index = parseInt(event.currentTarget.dataset.index)
    this.showTab(index)
  }

  showTab(index) {
    this.tabTargets.forEach((tab, i) => {
      tab.classList.toggle("tab--active", i === index)
      tab.classList.toggle("feed-tab--active", i === index)
    })
    this.panelTargets.forEach((panel, i) => {
      panel.classList.toggle("tab-content--active", i === index)
    })
  }
}
